// src/components/workspace/index.tsx
//
// The workspaces load only when a project is opened, so the editors (and
// the .zip library) never weigh on the rest of the site.

import { Suspense, lazy } from "react";
import type { ComponentProps } from "react";
import { createPortal } from "react-dom";
import { Loader2 } from "lucide-react";

const Overlay = lazy(() => import("./WorkspaceOverlay"));
const Viewer = lazy(() => import("./WorkspaceOverlay").then((m) => ({ default: m.ProjectViewer })));

function Opening() {
  return createPortal(
    <div className="fixed inset-0 z-[60] flex items-center justify-center gap-3 bg-[#f5f4ef] text-[15px] font-semibold text-[#1b2d5e]">
      <Loader2 className="h-5 w-5 animate-spin" /> Opening…
    </div>,
    document.body,
  );
}

export function WorkspaceOverlay(props: ComponentProps<typeof Overlay>) {
  return (
    <Suspense fallback={<Opening />}>
      <Overlay {...props} />
    </Suspense>
  );
}

export function ProjectViewer(props: ComponentProps<typeof Viewer>) {
  return (
    <Suspense fallback={<Opening />}>
      <Viewer {...props} />
    </Suspense>
  );
}
